import React from "react";
import {KatAccordionItem} from "@amzn/katal-react";
import {HealthIndicator} from "src/components/healthDashboard/HealthIndicator";
import {EventCard} from "src/components/healthDashboard/EventCard";
import {MetadataCard} from "src/components/healthDashboard/editableView/MetadataCard";
import {IEvent} from "src/context/models/Event";
import {IOperationMetadata} from "src/context/models/Metadata";
import {IOperation} from "src/context/models/Section";
import {capitalizeFirstLetter} from "src/common/utils/commonUtil";
import {useTranslation} from "react-i18next";
import {UpdateEventButton} from "src/components/healthDashboard/editableView/UpdateEventButton";
import {isSpectrumHubSite} from "src/common/utils/dashboardUtils";

type Props = {
    sectionName: string,
    operation: IOperation,
    openEvent: IEvent | undefined,
    metadata: IOperationMetadata | undefined
};
export const Operation: React.FC<Props> = ({
                                               sectionName,
                                               operation,
                                               openEvent,
                                               metadata
                                           }) => {
    const {t} = useTranslation();
    const className = isSpectrumHubSite() ? "operation" : "operation operation-public";

    const operationContent = <div className="operation-content">
        {openEvent ? <EventCard event={openEvent}/> : null}
        {metadata ?
            <>
                <div className="spacer-xsmall"/>
                <MetadataCard metadata={metadata}/>
            </> : null}
        {!openEvent ?
            <>
                <div className="spacer-xsmall"/>
                <UpdateEventButton section={sectionName} operation={operation.operationId}
                                   event={undefined}/>
            </> : null}
        </div>

    return <KatAccordionItem className={className} label={t(capitalizeFirstLetter(operation.operationId))}
                             key={operation.operationId}>
        <HealthIndicator events={openEvent ? [openEvent] : undefined} sectionName={sectionName}
                         operationId={operation.operationId}/>
        {isSpectrumHubSite() && operationContent}
    </KatAccordionItem>
}